import { ResourceManager } from "@/components/admin/ResourceManager";

const ICON_OPTIONS = [
  "ShieldCheck",
  "Zap",
  "Leaf",
  "Droplets",
  "Heart",
  "Sun",
  "Sparkles",
  "Flower2",
].map((v) => ({ value: v, label: v }));

export const AdminBenefits = () => (
  <ResourceManager
    title="Manfaat Madu"
    description="Kelola kartu manfaat yang tampil di halaman utama."
    queryKey="benefits"
    endpoint="/benefits"
    columns={[
      { key: "title", label: "Judul" },
      { key: "icon", label: "Ikon" },
      { key: "position", label: "Urutan" },
    ]}
    fields={[
      { name: "title", label: "Judul", type: "text" },
      { name: "desc", label: "Deskripsi", type: "textarea" },
      { name: "icon", label: "Ikon", type: "select", options: ICON_OPTIONS },
      { name: "position", label: "Urutan Tampil", type: "number" },
    ]}
  />
);
